import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { User, Mail, Calendar, ArrowLeft, Save, Loader2, AlertCircle } from 'lucide-react'
import { supabase, isConfigured } from '../lib/supabase'

export default function Profile({ session }) {
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [avatar, setAvatar] = useState('')
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)

  useEffect(() => {
    if (!session) { navigate('/auth'); return }
    if (session.user.user_metadata?.name) setName(session.user.user_metadata.name)
  }, [session])

  const handleSave = async (e) => {
    e.preventDefault()
    if (!isConfigured || !supabase) {
      alert('Supabase belum dikonfigurasi')
      return
    }
    setSaving(true)
    try {
      const { error } = await supabase.auth.updateUser({ data: { name } })
      if (error) throw error
      setSaved(true)
      setTimeout(() => setSaved(false), 2000)
    } catch (e) {
      console.error('Update error:', e)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="pt-20 px-4 max-w-2xl mx-auto">
      <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-gray-400 hover:text-white mb-6 transition-colors">
        <ArrowLeft className="w-4 h-4" /> Kembali
      </button>

      <div className="glass rounded-2xl p-8">
        {!isConfigured && (
          <div className="mb-6 p-4 bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 text-sm rounded-lg flex items-start gap-3">
            <AlertCircle className="w-5 h-5 mt-0.5 flex-shrink-0" />
            <div>
              <p className="font-semibold">Supabase belum dikonfigurasi</p>
              <p className="text-xs opacity-80">Data profil tidak bisa disimpan tanpa koneksi Supabase.</p>
            </div>
          </div>
        )}
        <div className="flex items-center gap-4 mb-8">
          <div className="w-16 h-16 rounded-full bg-primary-500/20 flex items-center justify-center">
            <User className="w-8 h-8 text-primary-500" />
          </div>
          <div>
            <h1 className="text-2xl font-bold">Profil</h1>
            <p className="text-gray-400 text-sm">{session?.user?.email}</p>
          </div>
        </div>

        <form onSubmit={handleSave} className="space-y-6">
          <div>
            <label className="block text-sm font-medium mb-1 flex items-center gap-2"><User className="w-4 h-4 text-gray-400" /> Nama</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-dark-700 focus:ring-2 focus:ring-primary-500" placeholder="Nama Anda" disabled={!isConfigured} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 flex items-center gap-2"><Mail className="w-4 h-4 text-gray-400" /> Email</label>
            <input type="email" value={session?.user?.email || ''} disabled className="w-full px-4 py-3 rounded-lg border border-dark-700 opacity-50 cursor-not-allowed" />
          </div>
          <button type="submit" disabled={saving || !isConfigured} className="flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 disabled:opacity-50 transition-colors">
            {saving ? <Loader2 className="w-5 h-5 animate-spin" /> : <Save className="w-5 h-5" />}
            {saved ? 'Tersimpan!' : 'Simpan'}
          </button>
        </form>
      </div>
    </div>
  )
}
